import { PARTY } from "./shared";
import { PartyLogo } from "./PartyLogo";

function Bar({ d, r, o, ld, lr, total, needed }) {
  const pct = (n) => `${(n / Math.max(total, 1)) * 100}%`;
  return (
    <div className="relative mt-3">
      <div className="flex h-3.5 w-full overflow-hidden bg-white/10">
        <div style={{ width: pct(d), background: PARTY.D.solid }} className="transition-[width] duration-700" />
        <div style={{ width: pct(ld), background: PARTY.D.tint }} className="transition-[width] duration-700 opacity-70" />
        <div style={{ width: pct(o), background: PARTY.I.solid }} />
        <div className="flex-1" />
        <div style={{ width: pct(lr), background: PARTY.R.tint }} className="transition-[width] duration-700 opacity-70" />
        <div style={{ width: pct(r), background: PARTY.R.solid }} className="transition-[width] duration-700" />
      </div>
      <div className="absolute -top-1.5 -bottom-1.5 w-0.5 bg-white" style={{ left: pct(needed) }} />
    </div>
  );
}

export function ChamberCard({ title, kicker, d, r, o = 0, ld = 0, lr = 0, total, needed, footnote, testid }) {
  return (
    <div className="border border-white/15 bg-white/[0.04] backdrop-blur-md p-5 md:p-6 midterms-rise" data-testid={testid}>
      <div className="flex items-baseline justify-between">
        <div className="font-display text-2xl md:text-3xl font-black tracking-tight">{title}</div>
        <div className="text-[10px] font-mono-ed uppercase tracking-[0.2em] text-white/50">{kicker}</div>
      </div>
      <div className="mt-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <PartyLogo party="D" size={40} />
          <div>
            <div className="font-display text-4xl font-black tabular-nums leading-none" data-testid={`${testid}-dem`}>{d}</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-white/50 mt-1">Dem{ld ? ` · +${ld} lead` : ""}</div>
          </div>
        </div>
        <div className="flex items-center gap-3 text-right">
          <div>
            <div className="font-display text-4xl font-black tabular-nums leading-none" data-testid={`${testid}-rep`}>{r}</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-white/50 mt-1">{lr ? `+${lr} lead · ` : ""}Rep</div>
          </div>
          <PartyLogo party="R" size={40} />
        </div>
      </div>
      <Bar d={d} r={r} o={o} ld={ld} lr={lr} total={total} needed={needed} />
      <div className="mt-3 text-[11px] uppercase tracking-[0.16em] text-white/55">{footnote}</div>
    </div>
  );
}
